import { axios } from './index';

export default {
	/**
	 * Get all restaurants
	 */
	all(town_id, params) {
		return axios.get(`user_restaurants/${town_id}`, {
				params: params
			})
			.then(response => Promise.resolve(response.data))
			.catch(error => Promise.reject(error.response.data));
	},

    /**
     * Get restaurant with given ID
     */
	show(id) {
	    return axios.get('restaurants/' + id)
			.then(response => Promise.resolve(response.data))
			.catch(error => Promise.reject(error.response.data));	
	}
}


// WEBPACK FOOTER //
// ./src/services/restaurants.js